//--------------------------
// is characteristic skill
//--------------------------
export default function isCharacteristicSkill(skill, pfx) {
  return skill.formula_arg1 == pfx || skill.formula_arg2 == pfx || skill.formula_arg3 == pfx ||
         skill.parent_formula_arg1 == pfx || skill.parent_formula_arg2 == pfx || skill.parent_formula_arg3 == pfx
}
